<template>
    <transition name="backT">
        <div :class="['BackNavigation', {'is-white': $route.name == 'about' }]">
            <span @click="onClick" class="BackNavigation-content" tag="span">
                Back
            </span> 
        </div>
    </transition>
</template>

<script>
import Store from '@/stores/store.js'
export default {
    name: 'BackNavigation',
    methods: {
        onClick() {
            if( Store.state.level == 2){
                this.lockCursor()
                this.$router.push( this.$route.matched[0].path.replace('/:slug', '') )
                return;
            }
            if( Store.state.level == 1){
                this.lockCursor()
                this.$router.push( "/" )
                return;
            }
        },
        lockCursor() {
            /**
             * This locks clicks to prevent conflict with raycasting click
             */
            Store.state.cursorLocked = true
            setTimeout(() => {
                Store.state.cursorLocked = false 
            }, 200);
        }
    }
}
</script>


<style scoped lang="scss">
    .BackNavigation{
        position: fixed;
        top: 0;
        left: 0;
        height: 65px;
        width: 100%;
        padding-left: 20px;
        line-height: 65px;
        z-index: zindex(back);

        background-color: rgba(0,0,0,1);
        transform: translateZ(0);

        &:after{
            content: "";
            position: absolute;
            top: 95%;
            left: 0;
            width: 100%;
            height: 10vh;
            background: linear-gradient(to bottom, rgba(0,0,0,1) 0%,rgba(0,0,0,0) 100%);
            opacity: 1;
            transition: opacity .6s $ease-out-quint;
            pointer-events: none;
        }

        &:before{
            content: "";
            position: absolute;
            bottom: 100%;
            left: 0;
            width: 100%;
            height: 300px;
            background: black;
            opacity: 1;
            transition: opacity .6s $ease-out-quint;
            pointer-events: none;
        }

        &.is-white:after{
            opacity: 0;
        }

        &.is-white{
            background-color: rgba(0,0,0,0);
            color: (black);
        }

        &-content{
            text-transform: uppercase;
            font-variation-settings: "wght" 700, "wdth" 1;
            font-size: rem(22px);
            display: block;
        }
    }

    
    .backT-enter-active, .backT-leave-active {
        transition: background-color .6s $ease-out-quint;
        .BackNavigation-content{
            transition: transform .6s $ease-out-quint;
        }
    }

    .backT-leave-active {
        &:after{
            transition: opacity .3s $ease-out-quint;
        }
    }

    .backT-enter, .backT-leave-to {
        background-color: rgba(0,0,0,0);
        &:after{
            opacity: 0;
        }
        .BackNavigation-content{
            transform: translateX(-80vw) translateZ(0);
        }
    }
</style>
